import React from 'react';

// Five-persona vocabulary — must match the backend's Toolkit:AllowedPersonaTags.
// Until M1 IAM unifies role + persona, this list is duplicated from the
// frontend's existing PERSONA_PAGES map in App.js.
export const PERSONA_VOCAB = ['assessor', 'client', 'presales', 'csp', 'admin'];

const LABELS  = { assessor:'Assessor', client:'Client', presales:'Pre-sales', csp:'CSP', admin:'Admin' };
const COLORS  = { assessor:'#1565C0', client:'#2E7D32', presales:'#E65100', csp:'#0078D4', admin:'#455A64' };

/**
 * PersonaTagChips
 *
 * Renders the fixed five-persona vocabulary as toggleable chips. When `editable`
 * is false it's read-only (used inside library cards). When `editable` is true
 * it doubles as a multi-select (used in upload + edit forms).
 *
 * Props:
 *  - tags: string[]                — currently-selected tags (lowercase)
 *  - onChange?: (string[]) => void — required when editable is true
 *  - editable: boolean             — defaults to false
 *  - size?: 'sm' | 'md'            — defaults to 'md'
 */
export default function PersonaTagChips({ tags = [], onChange, editable = false, size = 'md' }) {
  const lowerSet = new Set((tags || []).map(t => (t || '').toLowerCase()));

  const toggle = (tag) => {
    if (!editable || !onChange) return;
    const next = new Set(lowerSet);
    if (next.has(tag)) next.delete(tag); else next.add(tag);
    onChange(Array.from(next));
  };

  const list = editable ? PERSONA_VOCAB : PERSONA_VOCAB.filter(t => lowerSet.has(t));

  if (!editable && list.length === 0) {
    return <span style={{fontSize:10,color:'#B0BAC5'}}>—</span>;
  }

  return (
    <div style={{display:'flex',flexWrap:'wrap',gap:4}}>
      {list.map(tag => {
        const selected = lowerSet.has(tag);
        const base = COLORS[tag] || '#455A64';
        return (
          <span
            key={tag}
            onClick={() => toggle(tag)}
            style={{
              fontSize: size === 'sm' ? 9 : 10,
              padding: size === 'sm' ? '2px 7px' : '3px 9px',
              borderRadius: 10,
              fontWeight: 500,
              userSelect: 'none',
              cursor: editable ? 'pointer' : 'default',
              background: selected ? base + '14' : 'transparent',
              color: selected ? base : '#B0BAC5',
              border: `1px solid ${selected ? base + '40' : '#E0E4E8'}`,
              transition: 'all 0.12s',
            }}
          >
            {LABELS[tag] || tag}
          </span>
        );
      })}
    </div>
  );
}
